import { SET_FIELD_VALUE, SET_STATE, SET_CONJUGE, UPDATE_PESSOA,
  CADASTRO_INICIAL, CHANGE_TIPO_CADASTRANTE, CHANGE_ESTADO_CIVIL, CHANGE_NACIONALIDADE,
  CHANGE_POSSUI_CAR, CHANGE_HA_CONFLITOS, UPDATE_CAMPOS_RESERVA_LEGAL,
  UPDATE_CAMPOS_PRODUTIVIDADE, UPDATE_PRODUTIVIDADE_TIPO_AND_DOC, CHANGE_TIPO_INTERESSADO,
  SET_IS_VALIDACAO, UPDATE_DADOS_CADASTRANTE, UPDATE_GEORREFERENCIAMENTO
} from '../../../mutation-types'
import { cloneDeep, has, set } from 'lodash'
const { cadastro } = require('@/utils/' + process.env.ESTADO + '/cadastro')

const state = {
  cadastro: cadastro,
  cadastrante: null,
  interessado: null,
  conjuge: null,
  imovel: null,
  interessados: null,
  qualificacao: null,
  georreferenciamento: null,
  membrosComunidadeLista: null,
  representantes: null,
  beneficiarios: null,
  cadastroInicial: null,
  cadastranteInicial: null,
  versao: null,
  tipo: null,
  isValidoDestinacaoImovel: null,
  unicoUpdate: false
}

const getters = {
  cadastro: state => state.cadastro,
  cadastrante: state => state.cadastro.cadastrante,
  interessado: state => state.cadastro.interessado,
  cadastrantePessoa: state => state.cadastro.cadastrante.pessoa,
  cadastranteEndereco: state => state.cadastro.cadastrante.pessoa.endereco,
  interessadoPessoa: state => state.cadastro.interessado.pessoa,
  interessadoEndereco: state => state.cadastro.interessado.pessoa.endereco,
  interessadoConjugePessoa: state => state.cadastro.interessado.conjuge.pessoa,
  conjuge: state => state.cadastro.interessado.conjuge,
  imovel: state => state.cadastro.imovel,
  interessados: state => state.cadastro.interessados,
  qualificacao: state => state.cadastro.qualificacao,
  georreferenciamento: state => state.cadastro.georreferenciamento,
  membrosComunidadeLista: state => state.cadastro.membrosComunidadeLista,
  representantes: state => state.cadastro.representantes,
  beneficiarios: state => state.cadastro.beneficiarios,
  cadastroInicial: state => state.cadastroInicial,
  cadastranteInicial: state => state.cadastranteInicial,
  versao: state => state.versao,
  tipo: state => state.tipo,
  isValidoDestinacaoImovel: state => state.isValidoDestinacaoImovel
}

const actions = {
  setIsValidoDestinacaoImovel ({ commit }, value) {
    commit(SET_IS_VALIDACAO, value)
  },
  setCadastro ({ commit }, value) {
    commit(SET_STATE, value)
  },
  setConjuge ({ commit }, value) {
    commit(SET_CONJUGE, value)
  },
  updateInteressado ({ commit }, { field, value }) {
    commit(SET_FIELD_VALUE, { field, value })
  },
  updateMunicipio ({ commit, state }, value) {
    const codigos = ['id', 'codigoEstado', 'nome']
    if (value) {
      codigos.forEach(cod => {
        const field = `cadastrante.pessoa.endereco.municipio.${cod}`
        const fields = field.split('.')
        const dadoToSave = value[cod]
        let newCadastro = ''
        if (dadoToSave) {
          newCadastro = actions.atualizarPropriedade(state.cadastro, fields, dadoToSave)
        } else {
          newCadastro = actions.atualizarPropriedade(state.cadastro, fields, field)
        }
        commit(SET_STATE, newCadastro)
      })
    }
  },
  updateObjeto ({ commit, state }, { value }) {
    if (value) {
      value.forEach(val => {
        if (val.value) {
          const fields = val.field.split('.')
          const newCadastro = actions.atualizarPropriedade(state.cadastro, fields, val.value)
          commit(SET_STATE, newCadastro)
        }
      })
    }
  },
  update ({ commit, state }, { field, value }) {
    if (value !== null && value !== undefined) {
      const fields = field.split('.')
      const newCadastro = actions.atualizarPropriedade(state.cadastro, fields, value)
      commit(SET_STATE, newCadastro)
    }
  },
  // updateNaturalidade ({ commit, state }, { field, value }) {
  //   if (value !== null && value !== undefined && state.cadastro?.interessado?.pessoa?.pessoaFisica?.naturalidade?.municipio?.id !== undefined) {
  //     const fields = field.split('.')
  //     const newCadastro = actions.atualizarPropriedade(state.cadastro, fields, value)
  //     commit(SET_STATE, newCadastro)
  //   } else {
  //     erro aquie
  //   }
  // },
  atualizarPropriedade (obj, fields, value) {
    const newObj = cloneDeep(obj)
    const lastField = fields.pop()
    let pointer = newObj
    for (const field of fields) {
      pointer = pointer[field]
    }
    pointer[lastField] = value
    return newObj
  },
  updateDestinacaoUsoImovelAtividades () {
    const cadastroInicial = JSON.parse(state.cadastroInicial)
    const destinacaoUsoImovel = cadastroInicial.destinacaoUsoImovel
    // VERIFICA SE EXISTE SEMOVENTES E SE HÁ CADASTROS ANTERIORES E ATUALIZA A VERSÃO DO OBJETO PARA O ATUAL
    if (destinacaoUsoImovel.semoventes.length > 0) {
      let listaNovosSemoventes = state.cadastro.destinacaoUsoImovel.semoventes.filter(item => item.tipoAtividadeProducao === undefined)
      destinacaoUsoImovel.semoventes.forEach(item => {
        if (item.tipoAtividadeProducao !== undefined) {
          const newObject = {
            area: 0,
            tipo: item.tipo,
            descTipo: item.tipoAtividadeProducao.descricao,
            numeroCabecas: item.numeroCabecas,
            descricao: item.descricao
          }
          listaNovosSemoventes.push(newObject)
          state.cadastro.destinacaoUsoImovel.semoventes = listaNovosSemoventes
        }
      })
    }
    // VERIFICA SE EXISTE EDIFICAÇÕES E SE HÁ CADASTROS ANTERIORES E ATUALIZA A VERSÃO DO OBJETO PARA O ATUAL
    if (destinacaoUsoImovel.edificacoes.length > 0) {
      let listaNovasEdificacoes = state.cadastro.destinacaoUsoImovel.edificacoes.filter(item => item.tipoAtividadeProducao === undefined)
      const listaUnidadeMedida = [
        {codigo: 'METROS', descricao: 'm'},
        {codigo: 'METROS_QUADRADOS', descricao: 'm²'},
        {codigo: 'METROS_CUBICOS', descricao: 'm³'},
        {codigo: 'QUILOMETROS', descricao: 'km'}
      ]
      destinacaoUsoImovel.edificacoes.forEach(item => {
        if (item.tipoAtividadeProducao !== undefined) {
          const unidadeMedida = listaUnidadeMedida.filter(unidade => unidade.codigo === item.unidadeArea)
          const newObject = {
            area: item.area,
            descTipo: item.tipoAtividadeProducao.descricao,
            funcao: item.funcao,
            tipo: item.tipoAtividadeProducao.codigo,
            descricao: item.descricao,
            unidadeArea: item.unidadeArea,
            descUnidadeArea: unidadeMedida[0].descricao
          }
          listaNovasEdificacoes.push(newObject)
          state.cadastro.destinacaoUsoImovel.edificacoes = listaNovasEdificacoes
        }
      })
    }
    // VERIFICA SE EXISTE CULTURA PERMANENTE E SE HÁ CADASTROS ANTERIORES E ATUALIZA A VERSÃO DO OBJETO PARA O ATUAL
    if (destinacaoUsoImovel.culturasPermanentes.length > 0) {
      let listaNovasCulturasPermanentes = state.cadastro.destinacaoUsoImovel.culturasPermanentes.filter(item => item.tipoAtividadeProducao === undefined)
      destinacaoUsoImovel.culturasPermanentes.forEach(item => {
        if (item.tipoAtividadeProducao !== undefined) {
          const newObject = {
            area: item.area,
            descTipo: item.tipoAtividadeProducao.descricao,
            descricao: item.descricao,
            tipo: item.tipo
          }
          listaNovasCulturasPermanentes.push(newObject)
          state.cadastro.destinacaoUsoImovel.culturasPermanentes = listaNovasCulturasPermanentes
        }
      })
    }
    // VERIFICA SE EXISTE CULTURA TEMPORARIA E SE HÁ CADASTROS ANTERIORES E ATUALIZA A VERSÃO DO OBJETO PARA O ATUAL
    if (destinacaoUsoImovel.culturasTemporarias.length > 0) {
      let listaNovasCulturasTemporarias = state.cadastro.destinacaoUsoImovel.culturasTemporarias.filter(item => item.tipoAtividadeProducao === undefined)
      destinacaoUsoImovel.culturasTemporarias.forEach(item => {
        if (item.tipoAtividadeProducao !== undefined) {
          const newObject = {
            area: item.area,
            descTipo: item.tipoAtividadeProducao.descricao,
            descricao: item.descricao,
            tipo: item.tipo
          }
          listaNovasCulturasTemporarias.push(newObject)
          state.cadastro.destinacaoUsoImovel.culturasTemporarias = listaNovasCulturasTemporarias
        }
      })
    }
    // VERIFICA SE EXISTE OUTRAS ATIVIDADES E SE HÁ CADASTROS ANTERIORES E ATUALIZA A VERSÃO DO OBJETO PARA O ATUAL
    if (destinacaoUsoImovel.outrasAtividades.length > 0) {
      let listaNovasOutrasAtividades = state.cadastro.destinacaoUsoImovel.outrasAtividades.filter(item => item.tipoAtividadeProducao === undefined)
      destinacaoUsoImovel.outrasAtividades.forEach(item => {
        if (item.tipoAtividadeProducao !== undefined) {
          const newObject = {
            area: item.area,
            tipo: item.tipo,
            observacoes: item.observacoes,
            descricao: item.descricao
          }
          listaNovasOutrasAtividades.push(newObject)
          state.cadastro.destinacaoUsoImovel.outrasAtividades = listaNovasOutrasAtividades
        }
      })
    }
  },
  updaTeCadastranteIncial (payload) {
    if (payload.membrosComunidade !== undefined && !payload.pessoa.isPessoaFisica) {
      const newObjectCadastrantePJ = {
        pessoa: {
          telefones: payload?.pessoa?.telefones ? payload.pessoa.telefones : null,
          email: payload?.pessoa?.email ? payload.pessoa.email : null,
          endereco: {
            cep: payload?.pessoa?.endereco?.cep ? payload.pessoa.endereco.cep : null,
            bairro: payload?.pessoa?.endereco?.bairro ? payload.pessoa.endereco.bairro : null,
            municipio: {
              id: payload?.pessoa?.endereco?.municipio?.id
                ? payload.pessoa.endereco.municipio.id
                : null,
              nome: payload?.pessoa?.endereco?.municipio?.nome
                ? payload.pessoa.endereco.municipio.nome
                : null,
              estado: payload?.pessoa?.endereco?.municipio?.codigoEstado
                ? payload.pessoa.endereco.municipio.codigoEstado
                : payload.pessoa.endereco.municipio.estado
            },
            semNumero: payload?.pessoa?.endereco?.semNumero
              ? payload.pessoa.endereco.semNumero
              : null,
            numero: payload?.pessoa?.endereco?.numero
              ? payload.pessoa.endereco.numero : 0,
            logradouro: payload?.pessoa?.endereco?.logradouro
              ? payload.pessoa.endereco.logradouro
              : null,
            complemento: payload?.pessoa?.endereco?.complemento
              ? payload.pessoa.endereco.complemento
              : null,
            municipios: []
          },
          erroBusca: null,
          pessoaJuridica: {
            cnpj: payload?.pessoa?.pessoaJuridica?.cnpj
              ? payload.pessoa.pessoaJuridica.cnpj
              : null,
            razaoSocial: payload?.pessoa?.pessoaJuridica?.razaoSocial
              ? payload.pessoa.pessoaJuridica.razaoSocial
              : null
          },
          pessoaFisica: {
            cpf: null,
            nome: null
          },
          isPessoaFisica: payload?.pessoa?.isPessoaFisica ? payload.pessoa.isPessoaFisica : false
        }
      }
      state.cadastro.cadastrante = newObjectCadastrantePJ
      state.cadastranteInicial = JSON.stringify(newObjectCadastrantePJ)
    } else if (payload.membrosComunidade !== undefined && payload.pessoa.isPessoaFisica) {
      const newObjectCadastrantePF = {
        pessoa: {
          telefones: payload?.pessoa?.telefones ? payload.pessoa.telefones : null,
          email: payload?.pessoa?.email ? payload.pessoa.email : null,
          endereco: {
            cep: payload?.pessoa?.endereco?.cep ? payload.pessoa.endereco.cep : null,
            bairro: payload?.pessoa?.endereco?.bairro ? payload.pessoa.endereco.bairro : null,
            municipio: {
              id: payload?.pessoa?.endereco?.municipio?.id
                ? payload.pessoa.endereco.municipio.id
                : null,
              nome: payload?.pessoa?.endereco?.municipio?.nome
                ? payload.pessoa.endereco.municipio.nome
                : null,
              estado: payload?.pessoa?.endereco?.municipio?.codigoEstado
                ? payload.pessoa.endereco.municipio.codigoEstado
                : payload.pessoa.endereco.municipio.estado
            },
            semNumero: payload?.pessoa?.endereco?.semNumero
              ? payload.pessoa.endereco.semNumero
              : null,
            numero: payload?.pessoa?.endereco?.numero
              ? payload.pessoa.endereco.numero
              : null,
            logradouro: payload?.pessoa?.endereco?.logradouro
              ? payload.pessoa.endereco.logradouro
              : null,
            complemento: payload?.pessoa?.endereco?.complemento
              ? payload.pessoa.endereco.complemento
              : null,
            municipios: []
          },
          erroBusca: null,
          pessoaJuridica: {
            cnpj: null,
            razaoSocial: null
          },
          pessoaFisica: {
            cpf: payload?.pessoa?.pessoaFisica?.cpf
              ? payload.pessoa.pessoaFisica.cpf
              : null,
            nome: payload?.pessoa?.pessoaFisica?.nome
              ? payload.pessoa.pessoaFisica.nome
              : null
          },
          isPessoaFisica: payload?.pessoa?.isPessoaFisica
            ? payload.pessoa.isPessoaFisica
            : true
        }
      }
      state.cadastro.cadastrante = newObjectCadastrantePF
      state.cadastranteInicial = JSON.stringify(newObjectCadastrantePF)
    } else {
      if (payload.pessoa.isPessoaFisica === null) {
        if (payload.pessoa.pessoaFisica.cpf) {
          payload.pessoa.isPessoaFisica = true
        } else {
          payload.pessoa.isPessoaFisica = false
        }
      }
      state.cadastranteInicial = JSON.stringify(payload)
      state.cadastro.cadastrante = payload
    }
  },
  getDescEstadoCivil (estadoCivil) {
    if (estadoCivil) {
      const estadosCivis = [{codigo: 'CASADO', desc: 'Casado(a)'}, {codigo: 'DIVORCIADO', desc: 'Divorciado(a)'},
        {codigo: 'SEPARADO', desc: 'Separado(a)'}, {codigo: 'SOLTEIRO', desc: 'Solteiro(a)'},
        {codigo: 'UNIAO_ESTAVEL', desc: 'União Estável'}, {codigo: 'UNIAO_HOMOAFETIVA', desc: 'União Homoafetiva'},
        {codigo: 'VIUVO', desc: 'Viúvo(a)'}
      ]
      return estadosCivis.filter(item => item.codigo === estadoCivil)[0].desc
    }
    return ''
  },
  updateInteressadoAntigosParaNovo (interessado) {
    if (interessado?.conjuge?.pessoaFisica) {
      const newObjectConjuge = {
        pessoa: {
          pessoaFisica: {
            rg: interessado?.conjuge?.pessoaFisica?.rg ? interessado.conjuge.pessoaFisica.rg : null,
            cpf: interessado?.conjuge?.pessoaFisica?.cpf ? interessado.conjuge.pessoaFisica.cpf : null,
            nome: interessado?.conjuge?.pessoaFisica?.nome ? interessado.conjuge.pessoaFisica.nome : null,
            municipio: {
              nome: interessado?.endereco?.municipio?.nome
                ? interessado.endereco.municipio.nome
                : null,
              estado: interessado?.endereco?.municipio?.estadoCod
                ? interessado.endereco.municipio.estadoCod
                : interessado?.endereco?.municipio?.estado
                  ? interessado.endereco.municipio.estado
                  : null
            },
            municipios: [],
            naturalidade: {
              municipio: {
                id: interessado?.conjuge?.pessoaFisica?.naturalidade?.municipio?.id
                  ? interessado.conjuge.pessoaFisica.naturalidade.municipio.id
                  : interessado.conjuge.pessoaFisica.naturalidade.id
                    ? interessado.conjuge.pessoaFisica.naturalidade.id
                    : null
              }
            },
            nacionalidade: interessado?.conjuge?.pessoaFisica?.nacionalidade
              ? interessado.conjuge.pessoaFisica.nacionalidade
              : null,
            dataNascimento: interessado?.conjuge?.pessoaFisica?.dataNascimento
              ? interessado.conjuge.pessoaFisica.dataNascimento
              : null,
            orgaoExpedidor: {
              codigo: interessado?.conjuge?.pessoaFisica?.codigoOrgaoExpedidor
                ? interessado.conjuge.pessoaFisica.codigoOrgaoExpedidor
                : interessado?.conjuge?.pessoaFisica?.orgaoExpedidor?.codigo
                  ? interessado.conjuge.pessoaFisica.orgaoExpedidor.codigo
                  : null,
              estado: interessado?.conjuge?.pessoaFisica?.estadoOrgaoExpedidor
                ? interessado.conjuge.pessoaFisica.estadoOrgaoExpedidor
                : interessado?.conjuge?.pessoaFisica?.orgaoExpedidor?.estado
                  ? interessado.conjuge.pessoaFisica.orgaoExpedidor.estado
                  : null
            },
            temCertidaoObito: interessado?.conjuge?.pessoaFisica?.temCertidaoObito
              ? interessado.conjuge.pessoaFisica.temCertidaoObito
              : null
          },
          isPessoaFisica: true
        }
      }
      state.cadastro.interessado.conjuge = newObjectConjuge
    } else if (interessado.pessoa.id !== undefined) {
      if (interessado.pessoa.isPessoaFisica) {
        const newObjInteressadoPessoaPF = {
          email: interessado?.pessoa?.email
            ? interessado.pessoa.email
            : null,
          endereco: {
            cep: interessado?.pessoa?.endereco?.cep
              ? interessado.pessoa.endereco.cep : null,
            bairro: interessado?.pessoa?.endereco?.bairro
              ? interessado.pessoa.endereco.bairro
              : null,
            municipio: {
              id: interessado?.pessoa?.endereco?.municipio?.id
                ? interessado.pessoa.endereco.municipio.id
                : null,
              nome: interessado?.pessoa?.endereco?.municipio?.nome
                ? interessado.pessoa.endereco.municipio.nome
                : null,
              estado: interessado?.endereco?.municipio?.estadoCod
                ? interessado.endereco.municipio.estadoCod
                : interessado?.endereco?.municipio?.estado
                  ? interessado.endereco.municipio.estado
                  : interessado?.pessoa?.endereco?.municipio?.codigoEstado
                    ? interessado.pessoa.endereco.municipio.codigoEstado
                    : null
            },
            semNumero: interessado?.pessoa?.endereco?.semNumero
              ? interessado.pessoa.endereco.semNumero
              : null,
            logradouro: interessado?.pessoa?.endereco?.logradouro
              ? interessado.pessoa.endereco.logradouro
              : null,
            numero: interessado?.pessoa?.endereco?.numero
              ? interessado.pessoa.endereco.numero
              : 0,
            municipios: [],
            complemento: interessado?.pessoa?.endereco?.complemento
              ? interessado.pessoa.endereco.complemento
              : null
          },
          telefones: interessado?.pessoa?.telefones
            ? interessado.pessoa.telefones
            : [],
          isPessoaFisica: interessado?.pessoa?.isPessoaFisica
            ? interessado.pessoa.isPessoaFisica
            : null,
          pessoaFisica: {
            rg: interessado?.pessoa?.pessoaFisica?.rg
              ? interessado.pessoa.pessoaFisica.rg
              : null,
            cpf: interessado?.pessoa?.pessoaFisica?.cpf
              ? interessado.pessoa.pessoaFisica.cpf
              : null,
            nome: interessado?.pessoa?.pessoaFisica?.nome
              ? interessado.pessoa.pessoaFisica.nome
              : null,
            apelido: interessado?.pessoa?.pessoaFisica?.apelido
              ? interessado.pessoa.pessoaFisica.apelido
              : null,
            municipio: {
              nome: interessado?.pessoa?.endereco?.municipio?.nome
                ? interessado.pessoa.endereco.municipio.nome
                : null,
              estado: interessado?.pessoa?.endereco?.municipio?.estadoCod
                ? interessado.pessoa.endereco.municipio.estadoCod
                : interessado?.pessoa?.endereco?.municipio?.estado
                  ? interessado.pessoa.endereco.municipio.estado
                  : interessado?.pessoa?.endereco?.municipio?.codigoEstado
                    ? interessado.pessoa.endereco.municipio.codigoEstado
                    : null
            },
            municipios: [],
            estadoCivil: interessado?.pessoa?.pessoaFisica?.estadoCivil
              ? interessado.pessoa.pessoaFisica.estadoCivil
              : null,
            naturalidade: {
              municipio: {
                id: interessado?.pessoa?.pessoaFisica?.naturalidade?.id
                  ? interessado.pessoa.pessoaFisica.naturalidade.id
                  : interessado?.pessoa?.pessoaFisica?.naturalidade?.municipio?.id
                    ? interessado.pessoa.pessoaFisica.naturalidade.municipio.id
                    : null
              }
            },
            nacionalidade: interessado?.pessoa?.pessoaFisica?.nacionalidade
              ? interessado.pessoa.pessoaFisica.nacionalidade
              : null,
            dataNascimento: interessado?.pessoa?.pessoaFisica?.dataNascimento
              ? interessado.pessoa.pessoaFisica.dataNascimento
              : null,
            orgaoExpedidor: {
              codigo: interessado?.pessoa?.pessoaFisica?.orgaoExpedidor?.codigo
                ? interessado.pessoa.pessoaFisica.orgaoExpedidor.codigo
                : interessado.pessoa.pessoaFisica.codigoOrgaoExpedidor
                  ? interessado?.pessoa?.pessoaFisica?.codigoOrgaoExpedidor
                  : null,
              estado: interessado?.pessoa?.pessoaFisica?.orgaoExpedidor?.estado
                ? interessado.pessoa.pessoaFisica.orgaoExpedidor.estado
                : interessado?.pessoa?.pessoaFisica?.estadoOrgaoExpedidor
                  ? interessado.pessoa.pessoaFisica.estadoOrgaoExpedidor
                  : null
            },
            descEstadoCivil: actions.getDescEstadoCivil(interessado.pessoa.pessoaFisica.estadoCivil)
          }
        }
        state.cadastro.interessado.pessoa = newObjInteressadoPessoaPF
      }
      if (interessado?.pessoa?.isPessoaFisica && (interessado.pessoa.pessoaFisica.estadoCivil === 'CASADO' || interessado.pessoa.pessoaFisica.estadoCivil === 'UNIAO_ESTAVEL' ||
        interessado.pessoa.pessoaFisica.estadoCivil === 'UNIAO_HOMOAFETIVA') && !interessado?.conjuge?.pessoaFisica
      ) {
        const newObjectConjuge = {
          pessoa: {
            pessoaFisica: {
              rg: interessado?.conjuge?.pessoa?.pessoaFisica?.rg ? interessado.conjuge.pessoa.pessoaFisica.rg : null,
              cpf: interessado?.conjuge?.pessoa?.pessoaFisica?.cpf ? interessado.conjuge.pessoa.pessoaFisica.cpf : null,
              nome: interessado?.conjuge?.pessoa?.pessoaFisica?.nome ? interessado.conjuge.pessoa.pessoaFisica.nome : null,
              municipio: {
                nome: interessado?.pessoa?.endereco?.municipio?.nome
                  ? interessado.pessoa.endereco.municipio.nome
                  : null,
                estadoCod: interessado?.pessoa?.endereco?.municipio?.estadoCod
                  ? interessado.pessoa.endereco.municipio.estadoCod
                  : null
              },
              municipios: [],
              naturalidade: {
                municipio: {
                  id: interessado?.conjuge?.pessoa?.pessoaFisica?.naturalidade?.municipio?.id
                    ? interessado.conjuge.pessoa.pessoaFisica.naturalidade.municipio.id
                    : interessado?.conjuge?.pessoa?.pessoaFisica?.naturalidade?.id
                      ? interessado.conjuge.pessoa.pessoaFisica.naturalidade.id
                      : null
                }
              },
              nacionalidade: interessado?.conjuge?.pessoa?.pessoaFisica?.nacionalidade
                ? interessado.conjuge.pessoa.pessoaFisica.nacionalidade
                : null,
              dataNascimento: interessado?.conjuge?.pessoa?.pessoaFisica?.dataNascimento
                ? interessado.conjuge.pessoa.pessoaFisica.dataNascimento
                : null,
              orgaoExpedidor: {
                codigo: interessado?.conjuge?.pessoaFisica?.codigoOrgaoExpedidor
                  ? interessado.conjuge.pessoaFisica.codigoOrgaoExpedidor
                  : interessado?.conjuge?.pessoaFisica?.orgaoExpedidor?.codigo
                    ? interessado.conjuge.pessoaFisica.orgaoExpedidor.codigo
                    : null,
                estado: interessado?.conjuge?.pessoaFisica?.estadoOrgaoExpedidor
                  ? interessado.conjuge.pessoaFisica.estadoOrgaoExpedidor
                  : interessado?.conjuge?.pessoaFisica?.orgaoExpedidor?.estado
                    ? interessado.conjuge.pessoaFisica.orgaoExpedidor.estado
                    : null
              },
              temCertidaoObito: interessado?.conjuge?.pessoa?.pessoaFisica?.temCertidaoObito
                ? interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito
                : null
            },
            isPessoaFisica: true
          }
        }
        state.cadastro.interessado.conjuge = newObjectConjuge
      } else if (interessado?.pessoa?.isPessoaFisica && interessado.pessoa.pessoaFisica.estadoCivil === 'VIUVO' && !interessado?.conjuge?.pessoaFisica) {
        const newObjectConjuge = {
          pessoa: {
            pessoaFisica: {
              rg: interessado?.conjuge?.pessoaFisica?.rg
                ? interessado.conjuge.pessoaFisica.rg
                : null,
              cpf: interessado?.conjuge?.pessoaFisica?.cpf
                ? interessado.conjuge.pessoaFisica.cpf
                : null,
              nome: interessado?.conjuge?.pessoaFisica?.nome
                ? interessado.conjuge.pessoaFisica.nome
                : null,
              naturalidade: {
                municipio: {
                  id: null
                }
              },
              municipio: {
                nome: null,
                estadoCod: null
              },
              municipios: [],
              nacionalidade: interessado?.conjuge?.pessoaFisica?.nacionalidade
                ? interessado.conjuge.pessoaFisica.nacionalidade
                : null,
              dataNascimento: interessado?.conjuge?.pessoaFisica?.dataNascimento
                ? interessado.conjuge.pessoaFisica.dataNascimento
                : null,
              temCertidaoObito: interessado?.conjuge?.pessoaFisica?.temCertidaoObito
                ? interessado.conjuge.pessoaFisica.temCertidaoObito
                : null,
              codigoOrgaoExpedidor: null,
              estadoOrgaoExpedidor: null
            },
            isPessoaFisica: true
          }
        }
        state.cadastro.interessado.conjuge = newObjectConjuge
      }
    }
    if (state?.cadastro?.interessado?.conjuge && state?.cadastro?.interessado?.conjuge?.pessoa?.pessoaFisica?.naturalidade?.municipio?.id === undefined) {
      state.cadastro.interessado.conjuge.pessoa.pessoaFisica.naturalidade = {municipio: { id: null }}
    }
    if (!has(interessado, 'pessoa.endereco.numero')) {
      set(interessado, 'pessoa.endereco.numero', 0)
    }
  },
  updateGeorreferenciamento (payload) {
    // Garante que 'documentosRemovidos' existe
    if (!has(state.cadastro, 'georreferenciamento.documentosRemovidos')) {
      set(state.cadastro, 'georreferenciamento.documentosRemovidos', [])
    }
    // Função para atualizar o georreferenciamento com base no cadastro fornecido
    const updateGeorreferenciamento = (cadastro) => {
      state.cadastro.georreferenciamento.localizacoes = cadastro.georreferenciamento.localizacoes
      state.cadastro.georreferenciamento.documentos = cadastro.georreferenciamento.documentos
      state.cadastro.georreferenciamento.responsavel = cadastro.georreferenciamento.responsavel
      state.cadastro.georreferenciamento.jsonPlanilha = cadastro.georreferenciamento.jsonPlanilha
      state.cadastro.georreferenciamento.tipoPlanilha = cadastro.georreferenciamento.tipoPlanilha
      state.cadastro.georreferenciamento.documentosRemovidos = cadastro.georreferenciamento.documentosRemovidos
    }
    // Atualiza os dados com base no payload

    updateGeorreferenciamento(state.cadastro)

    if (state.cadastro.georreferenciamento.jsonPlanilha === undefined && payload === 'POSSUI') {
      state.cadastro.georreferenciamento.documentos = state.cadastro.georreferenciamento.documentos.filter(doc => !doc.fileName.includes('.ods'))
    }
  }
}

const mutations = {
  [SET_FIELD_VALUE] (state, { field, value }) {
    state.cadastro[field] = Object.assign({}, state.cadastro[field], value)
  },
  [SET_IS_VALIDACAO] (state, {value}) {
    state.isValidoDestinacaoImovel = value
  },
  [SET_STATE] (state, value) {
    const merge = Object.assign({}, state.cadastro, value)
    state.cadastro = merge
  },
  [UPDATE_PESSOA] (state, { fields, value }) {
    const newObject = cloneDeep(state.cadastro)
    const updatedCadastro = actions.atualizarPropriedade(newObject, fields, value)
    state.cadastro = updatedCadastro
  },
  [CADASTRO_INICIAL] (state, payload) {
    // TO DO VERIFICAR PQ AO DAR O F5 ESTÁ PERDENDO O TIPO E A VERSÃO DO CADASTRO, PROBLEMA POSSA ESTAR OCORRENDO NO SAVE
    const dadosCadastro = payload?.dados ? payload.dados.cadastro : payload
    if (dadosCadastro) {
      if (dadosCadastro.tipo || dadosCadastro.versao) {
        state.versao = JSON.stringify(payload.versao)
        state.tipo = JSON.stringify(payload.tipo)
      }
      state.cadastro = dadosCadastro
      if (dadosCadastro.destinacaoUsoImovel?.produtividade === undefined) {
        dadosCadastro.destinacaoUsoImovel.produtividade = cadastro.destinacaoUsoImovel.produtividade
      }
      if (
        (
          dadosCadastro.georreferenciamento.documentos.length > 0 &&
          dadosCadastro.georreferenciamento.localizacoes.length > 0
        ) ||
        (
          dadosCadastro.georreferenciamento.documentos.length === 0 &&
          dadosCadastro.georreferenciamento.localizacoes.length > 0
        )
      ) {
        dadosCadastro.georreferenciamento = {
          documentos: cadastro.georreferenciamento.documentos,
          responsavel: cadastro.georreferenciamento.responsavel,
          jsonPlanilha: cadastro.georreferenciamento.jsonPlanilha,
          tipoPlanilha: cadastro.georreferenciamento.tipoPlanilha,
          denominacao: cadastro.georreferenciamento.denominacao,
          documentosRemovidos: cadastro.georreferenciamento.documentosRemovidos,
          localizacoes: dadosCadastro.georreferenciamento.localizacoes,
          possuiGeorreferenciamento: 'NAO_POSSUI'
        }
      }
      state.cadastroInicial = JSON.stringify(dadosCadastro)
      if (dadosCadastro.cadastrante) {
        actions.updaTeCadastranteIncial(dadosCadastro.cadastrante)
        actions.updateDestinacaoUsoImovelAtividades()
        actions.updateInteressadoAntigosParaNovo(dadosCadastro.interessado)
        actions.updateGeorreferenciamento(dadosCadastro.georreferenciamento.possuiGeorreferenciamento)
      } else {
        const formulario = JSON.parse(dadosCadastro.json)
        actions.updaTeCadastranteIncial(formulario.dados.cadastro.cadastrante)
        actions.updateDestinacaoUsoImovelAtividades()
        actions.updateInteressadoAntigosParaNovo(formulario.dados.cadastro.interessado)
        actions.updateGeorreferenciamento(formulario.dados.cadastro.georreferenciamentopossuiGeorreferenciamento)
      }
    }
  },
  [CHANGE_TIPO_CADASTRANTE] (state, payload) {
    const cadastranteInicial = JSON.parse(state.cadastranteInicial)
    // TO DO MAPEAR O CADASTRO INICIAL E ANALISAR SE ALTERAR O TIPO E VOLTAR P O INICIAL
    // RETORNAR O VALOR ANTIGO E QUANDO ALTERAR APAGAR OS DADOS DE TODOS OS CAMPOS INICIAIS.
    if (cadastranteInicial?.pessoa?.isPessoaFisica === payload) {
      state.cadastro.cadastrante = cadastranteInicial
    } else {
      state.cadastro.cadastrante = cadastro.cadastrante
      state.cadastro.cadastrante.pessoa.isPessoaFisica = payload
    }
  },
  [CHANGE_TIPO_INTERESSADO] (state, payload) {
    const cadastroInicial = JSON.parse(state.cadastroInicial)
    if (cadastroInicial.interessado.pessoa.isPessoaFisica === payload) {
      state.cadastro.interessado = cadastroInicial.interessado
    } else {
      state.cadastro.interessado.pessoa = cadastro.interessado.pessoa
      state.cadastro.interessado.conjuge = cadastro.interessado.conjuge
      state.cadastro.interessado.documentos = cadastro.interessado.documentos
      state.cadastro.interessado.sociosRepresentantesLegais = cadastro.interessado.sociosRepresentantesLegais
      state.cadastro.interessado.idsSociosRepresentantes = cadastro.interessado.idsSociosRepresentantes
    }
  },
  [CHANGE_ESTADO_CIVIL] (state, payload) {
    const cadastroInicial = JSON.parse(state.cadastroInicial)
    const listaConjuge = ['CASADO', 'UNIAO_HOMOAFETIVA', 'UNIAO_ESTAVEL', 'VIUVO']
    if (
      (listaConjuge.includes(payload) && cadastroInicial.interessado.conjuge === undefined) ||
      !listaConjuge.includes(payload)
    ) {
      state.cadastro.interessado.conjuge = cadastro.interessado.conjuge
    } else if (listaConjuge.includes(payload) && cadastroInicial.interessado.conjuge !== undefined) {
      state.cadastro.interessado.conjuge = cadastroInicial.interessado.conjuge
    }
    if (listaConjuge.includes(payload) && payload !== 'VIUVO') {
      state.cadastro.interessado.conjuge.temCertidaoObito = null
    }
  },
  [CHANGE_NACIONALIDADE] (state, payload) {
    // Validação para quando o interessado não for brasileiro
    const newNaCionalidade = {
      municipio: {
        id: ''
      }
    }
    if (payload.value !== 'BR' && payload.codigo === 'INTERESSADO') {
      if (state?.cadastro?.interessado?.pessoa?.pessoaFisica?.naturalidade?.municipio !== undefined) {
        state.cadastro.interessado.pessoa.pessoaFisica.naturalidade.municipio = {id: ''}
      } else {
        state.cadastro.interessado.pessoa.pessoaFisica.naturalidade = newNaCionalidade
      }
    } else if (payload.value !== 'BR' && payload.codigo === 'CONJUGE') {
      if (state?.cadastro?.interessado?.conjuge?.pessoa?.pessoaFisica?.naturalidade?.municipio !== undefined) {
        state.cadastro.interessado.conjuge.pessoa.pessoaFisica.naturalidade.municipio = {id: ''}
      } else {
        state.cadastro.interessado.conjuge.pessoa.pessoaFisica.naturalidade = newNaCionalidade
      }
    }
  },
  [CHANGE_POSSUI_CAR] (state, payload) {
    const cadastroInicial = JSON.parse(state.cadastroInicial)
    if (payload) {
      state.cadastro.imovel.numeroReciboCar = cadastroInicial.imovel.numeroReciboCar
      state.cadastro.imovel.descricaoAcesso = null
      state.cadastro.imovel.area = cadastro.imovel.area
      state.cadastro.imovel.municipio = cadastro.imovel.municipio
      state.cadastro.imovel.nome = cadastro.imovel.nome
    } else {
      state.cadastro.imovel.numeroReciboCar = cadastro.imovel.numeroReciboCar
      state.cadastro.imovel.descricaoAcesso = cadastroInicial.imovel?.localicazacao || cadastroInicial.imovel?.descricaoAcesso
      state.cadastro.imovel.area = cadastroInicial.imovel.area
      state.cadastro.imovel.municipio = cadastroInicial.imovel.municipio || cadastro.imovel.municipio
      state.cadastro.imovel.nome = cadastroInicial.imovel.nome
    }
  },
  [CHANGE_HA_CONFLITOS] (state, payload) {
    const cadastroInicial = JSON.parse(state.cadastroInicial)
    if (payload) {
      state.cadastro.imovel.numeroProcessoJudicial = cadastroInicial.imovel.numeroProcessoJudicial
    } else {
      state.cadastro.imovel.numeroProcessoJudicial = cadastro.imovel.numeroProcessoJudicial
    }
  },
  [UPDATE_CAMPOS_RESERVA_LEGAL] (state, payload) {
    const cadastroInicial = JSON.parse(state.cadastroInicial)
    if (payload === 'SIM') {
      state.cadastro.destinacaoUsoImovel.areaReservaLegal = cadastroInicial.destinacaoUsoImovel.areaReservaLegal
      state.cadastro.destinacaoUsoImovel.percentualAreaReservalegal = cadastroInicial.destinacaoUsoImovel.percentualAreaReservalegal
    } else {
      state.cadastro.destinacaoUsoImovel.areaReservaLegal = null
      state.cadastro.destinacaoUsoImovel.percentualAreaReservalegal = null
    }
  },
  [UPDATE_CAMPOS_PRODUTIVIDADE] (state, payload) {
    if (!payload) {
      state.cadastro.destinacaoUsoImovel.produtividade = {
        dap: '',
        documentos: [],
        documentosRemovidos: [],
        drp: '',
        possuiComprovante: false,
        tipo: ''
      }
    }
  },
  [UPDATE_PRODUTIVIDADE_TIPO_AND_DOC] (state, payload) {
    if (payload !== state.cadastro.destinacaoUsoImovel.produtividade.tipo) {
      state.cadastro.destinacaoUsoImovel.produtividade.documentos = []
    }
    switch (payload) {
      case 'OUTROS':
        state.cadastro.destinacaoUsoImovel.produtividade.drp = ''
        state.cadastro.destinacaoUsoImovel.produtividade.dap = ''
        break
      case 'DAP':
        state.cadastro.destinacaoUsoImovel.produtividade.drp = ''
        break
      default:
        state.cadastro.destinacaoUsoImovel.produtividade.dap = ''
        break
    }
  },
  [UPDATE_DADOS_CADASTRANTE] (state, payload) {
    const cadastroInicial = JSON.parse(state.cadastroInicial)
    if (payload) {
      state.cadastro.interessado.pessoa.pessoaFisica.nome = state.cadastro.cadastrante.pessoa.pessoaFisica.nome
      state.cadastro.interessado.pessoa.pessoaFisica.cpf = state.cadastro.cadastrante.pessoa.pessoaFisica.cpf
      state.cadastro.interessado.pessoa.endereco = state.cadastro.cadastrante.pessoa.endereco
    } else {
      state.cadastro.interessado.pessoa.pessoaFisica.nome = cadastroInicial.interessado.pessoa.pessoaFisica.nome
      state.cadastro.interessado.pessoa.pessoaFisica.cpf = cadastroInicial.interessado.pessoa.pessoaFisica.cpf
      state.cadastro.interessado.pessoa.endereco = cadastroInicial.interessado.pessoa.endereco
    }
  },
  [UPDATE_GEORREFERENCIAMENTO] (state, payload) {
    const cadastroInicial = JSON.parse(state.cadastroInicial)
    if (payload) {
      if (payload !== cadastroInicial.georreferenciamento.possuiGeorreferenciamento) {
        state.cadastro.georreferenciamento = cadastro.georreferenciamento
      } else if (payload === cadastroInicial.georreferenciamento.possuiGeorreferenciamento) {
        state.cadastro.georreferenciamento = cadastroInicial.georreferenciamento
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/retificacao.js